import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Home from "./pages/Home";
import Events from "./pages/Events";
import Predict from "./pages/Predict";
import Leagues from "./pages/Leagues";
import League from "./pages/League";
import JoinLeague from "./pages/JoinLeague";
import MyPredictions from "./pages/MyPredictions";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import Upgrade from "./pages/Upgrade";
import UpgradeSuccess from "./pages/UpgradeSuccess";
import Landing from "./pages/Landing";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";

function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  if (!currentUser) return <Navigate to="/login" />;
  if (!currentUser.emailVerified) return <Navigate to="/verify-email" />;
  return children;
}

function AppRoutes() {
  const { currentUser } = useAuth();

  return (
    <Routes>
      <Route path="/" element={currentUser ? <PrivateRoute><Home /></PrivateRoute> : <Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/events" element={<PrivateRoute><Events /></PrivateRoute>} />
      <Route path="/predict/:matchId" element={<PrivateRoute><Predict /></PrivateRoute>} />
      <Route path="/leagues" element={<PrivateRoute><Leagues /></PrivateRoute>} />
      <Route path="/league/:leagueId" element={<PrivateRoute><League /></PrivateRoute>} />
      <Route path="/join/:code" element={<PrivateRoute><JoinLeague /></PrivateRoute>} />
      <Route path="/my-predictions" element={<PrivateRoute><MyPredictions /></PrivateRoute>} />
      <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
      <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />
      <Route path="/upgrade" element={<PrivateRoute><Upgrade /></PrivateRoute>} />
      <Route path="/upgrade/success" element={<PrivateRoute><UpgradeSuccess /></PrivateRoute>} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;